import Vue from "vue"
import router from "@/router/router"
import store from "@/vuex/store"
import "@/util/nullability-functions"
import "@/util/trim-function"
import "@/plugin/vuex-router-sync"
import "@/plugin/element-ui"
import "@/plugin/axios"
import "@/plugin/vuelidate"
import "@/plugin/vue-scroll"
import "@/util/capitalize-first-char"
import "reflect-metadata"
import LoadingVue from "@/layout/loading/Loading.vue"
import VueI18n from "vue-i18n"
import Element, { Loading } from "element-ui"
import Layout from "@/layout/Layout.vue"
import ErrorPage from "@/layout/error/ErrorPage.vue"
import VueTheMask from "vue-the-mask"

Vue.use(VueTheMask)

import qz from "qz-tray"

qz.api.setPromiseType(function promise(resolver: any) {
  return new Promise(resolver)
})
qz.api.setWebSocketType(WebSocket)

const createHash = require("sha.js")

qz.api.setSha256Type((data: any) => {
  return createHash("sha256")
    .update(data)
    .digest("hex")
})

qz.security.setCertificatePromise((resolve: any, reject: any) => {
  Vue.$http
    .get("/qz-certificate.crt", {
      withCredentials: false,
      baseURL: process.env.VUE_APP_ROOT
    })
    .then(res => resolve(res.data))
    .catch(e => reject(e))
})

qz.security.setSignaturePromise((toSign: any) => {
  return (resolve: any, reject: any) => {
    Vue.$http
      .post("qz/sign", { request: toSign })
      .then(res => resolve(res.data))
      .catch(e => reject(e))
  }
})

Vue.use((Loading as any).directive)
Vue.use(VueI18n)
Vue.config.productionTip = false

const loading = new Vue({
  render: h => h(LoadingVue)
}).$mount("#app")
Promise.all([
  store.dispatch("getAuthenticatedUser").catch(error => {
    return error
  }),
  store.dispatch("getLanguagesFromBase"),
  store.dispatch("getEasyshipConfiguration")
])
  .then(() => {
    const i18n = new VueI18n({
      locale: exists(store.getters.loggedUser) ? store.getters.loggedUser.office.lang.toLowerCase() : "en",
      fallbackLocale: "en",
      messages: JSON.parse(JSON.stringify(store.state.languagesFromBase)),
      silentTranslationWarn: true
    })

    Vue.use(Element, {
      i18n: (key: string, value: string) => i18n.t(key, value)
    })

    loading.$destroy()
    const app = new Vue({
      router,
      store,
      i18n,
      render: h => h(Layout)
    }).$mount("#app")

    const showErrorMessage = (error: string) => {
      app.$message({
        message: error,
        type: "error"
      })
    }
    const h = app.$createElement

    // noinspection JSUnusedGlobalSymbols
    Vue.prototype.$error = showErrorMessage
    Vue.$error = showErrorMessage
  })
  .catch(() => {
    new Vue({
      router,
      render: h => h(ErrorPage)
    }).$mount("#app")
    loading.$destroy()
    router.push({ path: "/error" })
  })
